import styled from "styled-components";
import { ShowPotentialWarehousesPayload } from "../../../../../services/offers/show-potential-warehouses/types";
import { StyledButton } from "../../../../../components/Button/button";
import { useEffect, useMemo, useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { theme } from "../../../../../helpers/theme";
import { useMutation } from "@tanstack/react-query";
import { generateOfferForWarehouse } from "../../../../../services/offers/generate-offer-for-warehouse";
import { toast } from "react-toastify";
import { settings } from "../../../../../helpers/toast.settings";

interface PotentialWarehousesChooseProps {
  potentialWarehouses: ShowPotentialWarehousesPayload[];
  orderId: string;
  offerId: string | undefined;
}

const PotentialWarehousesChoose = ({
  potentialWarehouses,
  orderId,
  offerId,
}: PotentialWarehousesChooseProps) => {
  const [value, setValue] = useState<number>(0);
  const [showError, setShowError] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number((event.target as HTMLInputElement).value));
    setShowError(false);
  };
  const GenerateWarehouseOfferMutation = useMutation(
    generateOfferForWarehouse,
    {
      onSuccess: (res) => {
        toast.success("Wygenerowano pomyślnie!", {
          toastId: "GenerateWarehouseOfferMutationSuccess",
          ...settings,
        });
      },
      onError: (err: any) => {
        if (err.response.data.error_code === 3) {
          setShowError(true);
        }
      },
    }
  );

  const body = useMemo(
    () => ({
      id_magazyn:
        potentialWarehouses[value] && potentialWarehouses[value].id_magazyn,
      id_podwykonawcy:
        potentialWarehouses[value] &&
        potentialWarehouses[value].wykonawca[0].id_wykonawca,
      id_zamowienia: orderId,
      id_oferty: offerId,
    }),
    [potentialWarehouses[value]]
  );

  return (
    <PotentialWarehousesChooseContainer>
      {potentialWarehouses.length > 0 ? (
        <>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            {potentialWarehouses.map((item, index) => (
              <PotentialWarehousesChooseItem choosen={value === index}>
                <FormControlLabel
                  value={index}
                  control={<Radio />}
                  label={`Firma ${item.wykonawca[0].nazwa} : ${
                    item.kod_magazynu
                  } : ${item.adres?.kod_pocztowy && item.adres?.kod_pocztowy} ${
                    item.adres?.miejscowosc
                  }, ${item.adres?.ulica} ${
                    item.adres?.numer_budynku ? item.adres?.numer_budynku : ""
                  }${
                    item.adres?.numer_lokalu
                      ? "/" + item.adres?.numer_lokalu
                      : ""
                  } `}
                  labelPlacement="start"
                />
              </PotentialWarehousesChooseItem>
            ))}
          </RadioGroup>

          <SubmitButtonWrapper>
            <StyledButton
              type="submit"
              variant="contained"
              sx={{ width: "96%" }}
              disabled={GenerateWarehouseOfferMutation.isLoading}
              onClick={() => GenerateWarehouseOfferMutation.mutate(body)}
            >
              Zapisz
            </StyledButton>
          </SubmitButtonWrapper>
        </>
      ) : (
        <NoWarehousesInfo>
          Brak magazynów spełniających kryteria.
        </NoWarehousesInfo>
      )}
      {showError && (
        <WarehouseExistInfo>{`Oferta dla magazynu już istnieje lub Rodzaj oferty uniemożliwia wygenerowanie nowej oferty podwykonawcy`}</WarehouseExistInfo>
      )}
    </PotentialWarehousesChooseContainer>
  );
};

export default PotentialWarehousesChoose;

const PotentialWarehousesChooseContainer = styled.div`
  width: 70%;
  max-width: 580px;
  flex-wrap: wrap;
  margin-left: 30px;
  @media (max-width: 500px) {
    width: 80%;
    margin-left: 0;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
`;
const SubmitButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 576px;
  justify-content: center;
  //margin-top: 10px;
`;
const NoWarehousesInfo = styled.span`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
const WarehouseExistInfo = styled.span`
  margin-top: 16px;
  margin-left: 10px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.red01_alert};
`;

const PotentialWarehousesChooseItem = styled.div<{ choosen: boolean }>`
  display: flex;
  width: 98%;
  max-width: 560px;
  justify-content: flex-end;
  padding-right: 10px;
  ${(props: any) => props.choosen && "background-color: lightgray"};
  //background-color: red;
  margin-bottom: 20px;
`;
